export default __webpack_public_path__ + "static/media/victoria_nails_006.81ce1feb.jpg";